import React from 'react';
import styles from './StatCard.module.scss';

export const statCardVariants = {
  card: 'card',
  inline: 'inline',
};

export const StatCard = ({
  icon,
  iconBg,
  label,
  value,
  caption,
  size = 'default',
  variant = statCardVariants.card,
  mono = false,
  truncate = false,
  fullWidth = false,
  action,
}) => {
  const isInline = variant === statCardVariants.inline;

  return (
    <div
      className={`${styles.statCard} ${size === 'compact' ? styles.statCardCompact : ''} ${fullWidth ? styles.statCardFullWidth : ''} ${isInline ? styles.statCardInline : ''}`}
    >
      <div
        className={isInline ? styles.iconInline : styles.iconWrap}
        style={isInline ? undefined : { backgroundColor: iconBg }}
      >
        {icon}
      </div>
      <div className={styles.textStack}>
        <span className={styles.label}>{label}</span>
        <span
          className={`${styles.value} ${mono ? styles.valueMono : ''} ${truncate ? styles.valueTruncate : ''}`}
          title={truncate && typeof value === 'string' ? value : undefined}
        >
          {value}
        </span>
        {caption ? <span className={styles.caption}>{caption}</span> : null}
      </div>
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
};
